// extracted by mini-css-extract-plugin
export default {"container":"login_container__IRJFP","wrapper":"login_wrapper__3yeck","link":"login_link__-741R","span":"login_span__bIYx6","buttons":"login_buttons__uSPFH"};